import marketplace from 'cfg/marketplace.json';
import MelodyCardProduct from 'components/common/melodyCard/MelodyCardProduct';
import LandingPageLink from 'components/landing/LandingPageLink';

import css from 'styles/components/landing/productList.scss';

const { defaultComponentStyle, search: { msaMelodyImageParams, showRatingStars } } = marketplace;

const ProductList = ({ slotName, slotIndex, slotDetails, slotHeartsData, onHeartClick, hearts, heartsList, onLandingComponentClick }) => {
  const { title, products, monetateId, ctacopy, ctalink } = slotDetails;
  const linkProps = {
    'onClick': onLandingComponentClick,
    'data-eventlabel': 'productSearch - productList',
    'data-eventvalue': title,
    'data-slotindex': slotIndex
  };

  return (
    <div data-slot-id={slotName} className={css.container} data-monetate-id={monetateId}>
      {title && <h2>{title} <span><LandingPageLink url={ctalink} {...linkProps}>{ctacopy}</LandingPageLink></span></h2>}
      <div className={css.list}>
        {products.slice(0, 4).map(product => <MelodyCardProduct
          cardData={product}
          componentStyle={defaultComponentStyle}
          eventLabel="productSearchProductList"
          msaImageParams={msaMelodyImageParams}
          onComponentClick={onLandingComponentClick}
          key={product.styleId}
          shouldLazyLoad={true}
          noBackground={false}
          showRatingStars={showRatingStars}
          heartsData={slotHeartsData}
          onHeartClick={onHeartClick}
          hearts={hearts}
          heartsList={heartsList}
        />
        )}
      </div>
    </div>
  );
};

export default ProductList;
